/* Fill each batch with actual discounts, across Shopify's source pages. */
if (!customElements.get('pp-offers-feed')) {
  customElements.define('pp-offers-feed', class extends HTMLElement {
    connectedCallback() {
      this.grid = this.querySelector('#product-grid');
      this.button = this.querySelector('[data-offers-more]');
      if (!this.grid || !this.button) return;
      this.controls = this.querySelector('[data-offers-controls]');
      this.status = this.querySelector('[data-offers-status]');
      this.fallback = this.querySelector('[data-offers-pagination]');
      this.empty = this.querySelector('[data-offers-empty]');
      this.nextUrl = this.dataset.nextUrl;
      this.batchSize = Number(this.dataset.batchSize) || 48;
      this.queue = [];
      this.visited = new Set();
      this.seen = new Set(Array.from(this.grid.querySelectorAll('[data-offer-product-id]'), card => card.dataset.offerProductId));
      this.abortController = new AbortController();
      this.button.addEventListener('click', () => this.loadBatch(this.seen.size + this.batchSize), { signal: this.abortController.signal });
      this.fallback.hidden = true;
      this.loadBatch(this.batchSize);
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }

    async loadBatch(target) {
      if (this.loading) return;
      this.loading = true;
      this.button.disabled = true;
      this.setAttribute('aria-busy', 'true');
      this.controls.hidden = false;
      this.status.textContent = this.dataset.loadingLabel;
      if (this.empty) this.empty.hidden = true;
      let failed = false;
      try {
        while (this.seen.size < target && this.isConnected) {
          while (this.queue.length && this.seen.size < target) {
            const card = this.queue.shift();
            if (this.seen.has(card.dataset.offerProductId)) continue;
            this.seen.add(card.dataset.offerProductId);
            this.grid.appendChild(card);
          }
          if (this.seen.size >= target || !this.nextUrl) break;
          const url = new URL(this.nextUrl, window.location.href);
          url.searchParams.set('section_id', this.dataset.sectionId);
          const preview = new URL(window.location.href).searchParams.get('preview_theme_id');
          if (preview) url.searchParams.set('preview_theme_id', preview);
          if (url.origin !== window.location.origin || this.visited.has(url.href)) throw new Error('Invalid offers page');
          const response = await fetch(url.href, { signal: this.abortController.signal });
          if (!response.ok) throw new Error('Offers request failed');
          const html = new DOMParser().parseFromString(await response.text(), 'text/html');
          const feed = html.querySelector('pp-offers-feed');
          if (!feed) throw new Error('Missing offers grid');
          this.visited.add(url.href);
          this.queue.push(...feed.querySelectorAll('[data-offer-product-id]'));
          this.nextUrl = feed.dataset.nextUrl;
        }
        this.status.textContent = '';
        this.fallback.hidden = true;
      } catch (error) {
        if (error.name === 'AbortError') return;
        failed = true;
        this.status.textContent = this.dataset.errorLabel;
        this.fallback.hidden = false;
      } finally {
        this.loading = false;
        this.button.disabled = false;
        this.removeAttribute('aria-busy');
        this.controls.hidden = !failed && !this.nextUrl && !this.queue.length;
        if (this.empty) this.empty.hidden = this.seen.size > 0 || !!this.nextUrl || failed;
      }
    }
  });
}
